@if (shouldDisplayNavbar()) {
<mat-toolbar class="toolbar">

    <app-menu-settings [menuSettings]="menuSettings" [cesarApplications]="cesarApplications">
    </app-menu-settings>

    <a class="logo-link" routerLink="/dashboard">
        <img src="assets/images/tel4b.png" alt="tel4b" class="logo" />
    </a>

    <span class="application-title">Nexus</span>

    @if (currentOrganization) {
    <div class="org-display" [formGroup]="searchControl">
        <fa-icon class="filter-icon" [icon]="faFilter"></fa-icon>
        <mat-label class="filter-label">ORGANISATION :</mat-label>

        @if (!isEditable) {
        <span class="org-name" (click)="onEdit()">
            <mat-form-field appearance="outline" class="readonly-field">
                <input matInput formControlName="organization" readonly />
                <mat-icon matSuffix>edit</mat-icon>
            </mat-form-field>
        </span>
        } @else {
        <span class="org-search">
            <mat-form-field appearance="outline">
                <input matInput #searchInput formControlName="organizationControl" placeholder="Recherche..."
                    [matAutocomplete]="auto" (focus)="focus()" (blur)="blur()" />

                @if ((searchControl.get('organizationControl')?.value?.length ?? 0) < 1) { <mat-icon matSuffix>
                    search</mat-icon>
                    } @else {
                    <mat-icon matSuffix (click)="focus()">close</mat-icon>
                    }
                    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"
                        (optionSelected)="selectOrganization($event.option.value)">
                        @for (org of organizationsFilter; track org.id) {
                        <mat-option [value]="org">
                            {{ org.display }}
                        </mat-option>
                        }
                    </mat-autocomplete>
            </mat-form-field>
        </span>
        }
    </div>
    }

    <span class="spacer"></span>

    <div class="right-side">
        @if (currentUser) {
        <span class="welcome-message">
            Bonjour {{ fullName }}
        </span>
        }

        <mat-icon (click)="onThemeChange()">
            {{ isDarkMode ? 'light_mode' : 'dark_mode' }}
        </mat-icon>

        <mat-icon (click)="logout()" matTooltip="Se déconnecter">
            logout
        </mat-icon>
    </div>

</mat-toolbar>
}